import gql from 'graphql-tag';

const GET_USER_ADDRESSES = gql`
    query getUserAdresses($userProfileId: String) {
        getUserAddresses(userProfileId: $userProfileId) {
            id,
            addressLine,
            geoLocation {
                latitude,
                longitude
            },
            addressType
            receiverName
            addressName
            postalCode
            city
            state
            country
            street
            number
            neighborhood
            complement
            reference
            geoCoordinates
        }
    }
`;

export default GET_USER_ADDRESSES;
